import script from "./icon-logout.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-logout.vue?vue&type=script&lang=ts&setup=true"

import "./icon-logout.vue?vue&type=style&index=0&id=36300b0e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36300b0e"]])

export default __exports__